// ⚠️ このスクリプトの成功トーストは Bootstrap (window.bootstrap / bootstrap.Toast) に依存する。
//   Bootstrap は v1 レイアウト(theme.liquid / v1-theme.liquid)でのみ読み込まれ、
//   v2 レイアウト(v2-theme.liquid)では Tier 2-2 で除去済み。
//   v2 のトリガー要素 .wishlist-toggle は現状どの v2 セクションにも描画されないため
//   このトースト経路は v2 では到達しないが、将来 v2 のセクションに .wishlist-toggle を
//   追加すると v2 では bootstrap 未定義でエラーになる。
//   → v2 でお気に入りトーストが必要な場合は Bootstrap でなく Lit の kd-favorite-toast
//     (snippets/v2-favorite-toast.liquid) を使うこと。下の Toast 生成は typeof ガードで保護。
(async function () {
  const wishlistButtonCustom = document.querySelectorAll('.wishlist-toggle');
  wishlistButtonCustom.forEach((btn) => {
    btn.addEventListener('click', async (e) => {
      try {
        e.target.disabled = true;
        const btnData = e.target.dataset;
        e.preventDefault();
        if (e.target.classList.contains('swym-added')) {
          // Remove from wishlist
          const response = await fetch(`/apps/kuradashi-app-proxy/wishlist/${btnData.variantId}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          });
          switch (response.status) {
            case 204:
            case 404:
              // 404（既に未登録＝swym管理のvariant_idズレ等）も成功扱い。setRemoveButtonEvent と対称化
              e.target.classList.remove('swym-added');
              break;
            case 401:
              alert('お気に入り登録を削除するにはログインが必要です。');
              return;
            default:
              throw new Error('Failed to remove from wishlist');
          }
        } else {
          const response = await fetch(`/apps/kuradashi-app-proxy/wishlist`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: parseInt(btnData.variantId),
              handle: btnData.productHandle,
            }),
          });
          switch (response.status) {
            case 201:
            case 409:
              {
                e.target.classList.add('swym-added');
                const parentContainer = document.querySelector('#wishlist-notify-container');

                parentContainer.innerHTML = ''; // Reset old toasts;
                const productImageUrl = btnData.productImageUrl;
                const productTitle = btnData.productTitle;
                const toastDetails = `
                    <div style="z-index: 9999; max-width: 250px; position: fixed; display:block; left: 5px; top:84px">
                    <div aria-atomic="true d-flex" aria-live="polite" class="toast hide" id="wishlist-toast" role="alert">
                    <div class="toast-header">
                      <strong class="me-auto text-center">お気に入りに追加されました</strong>
                      <button aria-label="Close" class="btn-close" data-bs-dismiss="toast" type="button"></button>
                    </div>
                    <a class="toast-body d-flex" href="/pages/swym-wishlist" id="openWl">
                      <img alt="Image" class="rounded mr-2 img-thumbnail" src="${productImageUrl}">
                      <div class="me-auto text-center mt-2">
                        <span class="strong text-center text-truncate">${productTitle}</span>
                      </div>
                    </a>
                    </div>
                    </div>`;
                parentContainer.innerHTML = toastDetails;
                const toastElement = document.querySelector('#wishlist-toast');
                // Bootstrap は v2 レイアウトでは読み込まれない（Tier 2-2 で除去）。この経路は
                // v2 では到達しない想定だが、未定義時に ReferenceError で落とさないようガードする
                // （v2 でトーストが要る場合は Lit の kd-favorite-toast を使う。ファイル冒頭の注記参照）。
                if (typeof bootstrap !== 'undefined') {
                  const toast = new bootstrap.Toast(toastElement, {
                    autohide: true,
                    delay: 6000,
                    animation: true,
                  });
                  toast.show();
                }
              }
              break;
            case 401:
              alert('お気に入り登録にはログインが必要です。');
              return;
            default:
              throw new Error('Failed to add to wishlist');
          }
        }
      } finally {
        e.target.disabled = false;
      }
    });
  });

  function setRemoveButtonEvent() {
    const removeButtons = document.querySelectorAll('.wishlist-remove-productBtn');
    removeButtons.forEach((button) => {
      // 描画経路が複数回呼ぶため多重バインドを防ぐ（連打・二重発火の原因になる）
      if (button.dataset.removeBound === 'true') return;
      button.dataset.removeBound = 'true';
      button.addEventListener('click', async (event) => {
        // async 内では await 後に event.currentTarget が null 化するため同期的に捕捉する
        const btn = event.currentTarget;
        if (btn.disabled) return;
        btn.disabled = true;
        try {
          const variantId = btn.getAttribute('data-variant-id');
          const response = await fetch(`/apps/kuradashi-app-proxy/wishlist/${variantId}`, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            },
          });
          // 204（削除成功）/ 404（既に未登録＝実質削除済み。swym 管理の variant_id ズレでも成功扱い）を成功とする。
          // フルリロードせず該当アイテムのみ DOM から除去する（楽観的更新＝「重い」の解消）。
          if (response.status === 204 || response.status === 404) {
            const item = btn.closest('li');
            if (item) {
              item.remove();
            } else {
              // 万一 <li> 外にボタンがある場合、disabled のまま残さない（永久に押せなくなるのを防ぐ）
              btn.disabled = false;
            }
            // 残りが無くなったら空表示に切り替える
            if (document.querySelectorAll('.wishlist-remove-productBtn').length === 0) {
              const grid = document.getElementById('wishlist-grid');
              if (grid) {
                grid.innerHTML = 'お気に入り情報がありません。<br />お気に入りを追加してください。';
              }
            }
            return;
          }
          if (response.status === 401) {
            alert('お気に入り登録を削除するにはログインが必要です。');
            btn.disabled = false;
            return;
          }
          throw new Error(`Failed to remove from wishlist (status: ${response.status})`);
        } catch (error) {
          // 従来は catch が無く失敗が握り潰され「押しても何も起きない」状態だった
          console.error('[wishlist] remove failed:', error);
          alert('お気に入りの削除に失敗しました。時間をおいて再度お試しください。');
          btn.disabled = false;
        }
      });
    });
  }

  const wishlistGrid = document.getElementById('wishlist-grid');
  if (wishlistGrid) {
    const products = window.wishlist;
    if (products.length == 0) {
      wishlistGrid.innerHTML = 'お気に入り情報がありません。<br />お気に入りを追加してください。';
      return;
    }

    // productsが20件以上の場合はall_productの制約があるため20件ごとにリクエストを送る。
    const MAX_PRODUCT_COUNT = 20;
    try {
      if (products.length > MAX_PRODUCT_COUNT) {
        const promises = [];
        for (let i = 0; i < Math.ceil(products.length / MAX_PRODUCT_COUNT); i++) {
          const productInfo = products
            .slice(i * MAX_PRODUCT_COUNT, (i + 1) * MAX_PRODUCT_COUNT)
            .map((product) => `${product.handle};${product.id}`)
            .join(',');
          const url = `/pages/sections/product_handle=${productInfo}`;
          // TODO: Retain this line for reference in case the section_id needs to include the template ID dynamically.
          promises.push(fetch(`${url}?section_id=wishlist-product`));
        }
        const responses = await Promise.all(promises);
        const elements = await Promise.all(responses.map((response) => response.text()));

        // 最初のelementsのulタグにその他のelementsのliタグをループで取り出して追記する
        const ulCloseTag = '</ul>';
        const ulCloseTagIndex = elements[0].indexOf(ulCloseTag);
        elements[0] = elements[0].slice(0, ulCloseTagIndex);
        const liOpenTag = '<li';
        for (let i = 1; i < elements.length; i++) {
          if (i == elements.length - 1) {
            const liOpenTagIndex = elements[i].indexOf(liOpenTag);
            elements[i] = elements[i].slice(liOpenTagIndex);
            elements[0] += elements[i];
          } else {
            const liOpenTagIndex = elements[i].indexOf(liOpenTag);
            elements[i] = elements[i].slice(liOpenTagIndex);
            const deleteTagIndex = elements[i].indexOf(ulCloseTag);
            elements[i] = elements[i].slice(0, deleteTagIndex);
            elements[0] += elements[i];
          }
        }

        wishlistGrid.innerHTML = elements[0];
        const wishlistContainerElement = document.getElementById('main-collection-product-grid');
        wishlistContainerElement.classList.add('is-loaded');
        setRemoveButtonEvent();
        return;
      }
      // それ以外の場合は1回のリクエストで済むのでそのまま処理する。
      let productInfo = '';
      products.forEach((product, index) => {
        productInfo += `${product.handle};${product.id}`;
        if (index < products.length - 1) {
          productInfo += ',';
        }
      });
      const url = `/pages/sections/product_handle=${productInfo}`;
      const response = await fetch(`${url}?section_id=wishlist-product`);
      if (response.status === 200) {
        wishlistGrid.innerHTML = await response.text();
        const wishlistContainerElement = document.getElementById('main-collection-product-grid');
        wishlistContainerElement.classList.add('is-loaded');
        setRemoveButtonEvent();
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching wishlist products:', error);
      wishlistGrid.innerHTML = 'お気に入り情報の取得に失敗しました。<br />再読み込みしてください。';
      const wishlistContainerElement = document.getElementById('main-collection-product-grid');
      wishlistContainerElement.classList.add('is-loaded');
    }
  }

  // li要素のdata-quantityとdata-expirationを取得してSortByをIDにもつセレクトボックス値の変更によってソートする
  const sortBySelect = document.getElementById('SortBy');
  if (sortBySelect) {
    sortBySelect.addEventListener('change', function () {
      const wishlist = document.querySelectorAll('#main-collection-product-grid > li');
      switch (sortBySelect.value) {
        case 'stock': {
          wishlist.forEach((targetDOM) => {
            const quantity = Number(targetDOM.dataset.quantity);
            targetDOM.style.display = 'block';
            if (quantity == 0 || quantity > 20) {
              targetDOM.style.display = 'none';
            }
          });
          break;
        }
        case 'deadline': {
          const toDay = new Date().getTime();
          wishlist.forEach((targetDOM) => {
            const targetDate = targetDOM.dataset.deadline;
            if (targetDate) {
              const quantity = Number(targetDOM.dataset.quantity);
              const deadline = new Date(targetDate).getTime();
              targetDOM.style.display = 'block';
              // expirationDateが1月以上か売り切れの場合は非表示
              if (deadline - toDay > 864000000 || quantity == 0) {
                targetDOM.style.display = 'none';
              }
            } else {
              targetDOM.style.display = 'none';
            }
          });
          break;
        }
        case 'expiration': {
          if (wishlist.length === 0) return;
          // リストの全アイテムを表示状態にする
          wishlist.forEach((item) => {
            item.style.display = 'block';
          });
          // 賞味期限でアイテムをソート
          const sortedWishlist = Array.from(wishlist).sort((a, b) => {
            const getExpirationTime = (el) =>
              el.dataset.expiration ? new Date(el.dataset.expiration).getTime() : Infinity;
            const dateA = getExpirationTime(a);
            const dateB = getExpirationTime(b);
            // 両方のアイテムに賞味期限がない場合はIDでソート
            if (dateA === Infinity && dateB === Infinity) {
              return a.dataset.id.localeCompare(b.dataset.id);
            }
            // 賞味期限でソート
            return dateA - dateB;
          });
          const parent = document.getElementById('main-collection-product-grid');
          parent.innerHTML = '';
          // ソートされたアイテムを追加
          sortedWishlist.forEach((item) => parent.appendChild(item));
          break;
        }
        case 'free-shipping': {
          if (wishlist.length === 0) return;
          wishlist.forEach((targetDOM) => {
            const isFreeShippingStr = targetDOM.dataset.freeShipping;
            if (isFreeShippingStr === 'false') {
              targetDOM.style.display = 'none';
            } else {
              targetDOM.style.display = 'block';
            }
          });
          break;
        }
        case 'free-cool-flight': {
          if (wishlist.length === 0) return;
          wishlist.forEach((targetDOM) => {
            const isFreeCoolFlightStr = targetDOM.dataset.freeCoolFlight;
            if (isFreeCoolFlightStr === 'false') {
              targetDOM.style.display = 'none';
            } else {
              targetDOM.style.display = 'block';
            }
          });
          break;
        }
        case 'free-shipping-and-free-cool-flight': {
          if (wishlist.length === 0) return;
          wishlist.forEach((targetDOM) => {
            const isFreeShippingAndFreeCoolFlightStr = targetDOM.dataset.freeShippingAndFreeCoolFlight;
            if (isFreeShippingAndFreeCoolFlightStr === 'false') {
              targetDOM.style.display = 'none';
            } else {
              targetDOM.style.display = 'block';
            }
          });
          break;
        }
        case 'under-3000': {
          wishlist.forEach((targetDOM) => {
            const price = Number(targetDOM.dataset.price || 0);
            if (price >= 3000) {
              targetDOM.style.display = 'none';
            } else {
              targetDOM.style.display = 'block';
            }
          });
          break;
        }
        case 'under-2000': {
          wishlist.forEach((targetDOM) => {
            const price = Number(targetDOM.dataset.price || 0);
            if (price >= 2000) {
              targetDOM.style.display = 'none';
            } else {
              targetDOM.style.display = 'block';
            }
          });
          break;
        }
        case 'under-1000': {
          wishlist.forEach((targetDOM) => {
            const price = Number(targetDOM.dataset.price || 0);
            if (price >= 1000) {
              targetDOM.style.display = 'none';
            } else {
              targetDOM.style.display = 'block';
            }
          });
          break;
        }
        default:
          wishlist.forEach((targetDOM) => {
            targetDOM.style.display = 'block';
          });
          break;
      }
    });
  }
})();
